import { db } from "../../../firebaseConfig";
import {
    collection,
    getDocs
} from "firebase/firestore";

export const fetchWithdrawals = async (userId, setWithdrawals) => {
    try {
        const partnersRef = collection(db, "users", userId, "partners");

        const snapshot = await getDocs(partnersRef);

        let allWithdrawals = [];

        snapshot.forEach(doc => {
            const partnerId = doc.id;
            const data = doc.data();

            const withdrawals = data.withdrawals || [];

            // ✅ FIXED STRUCTURE
            const formatted = withdrawals.map(w => ({
                partnerId: partnerId,        // ✅ CORRECT KEY
                partnerName: data.name,
                amount: Number(w.amount),
                date: w.date
            }));

            allWithdrawals = [...allWithdrawals, ...formatted];
        });

        // optional: sort by latest first
        allWithdrawals.sort((a, b) => new Date(b.date) - new Date(a.date));

        setWithdrawals(allWithdrawals);

    } catch (error) {
        console.error("Error fetching withdrawals:", error);
    }
};